import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.actionVariantPage.actionsModalTitle, 'Variant actions'),
  cancel: () => __(translations.actionVariantModal.cancel, 'Cancel'),
  yesImSure: () => __(translations.actionVariantModal.yesImSure, "Yes, I'm sure"),
  inputLabel: () => __(translations.actionVariantModal.inputLabel, 'Select a target Product'),
};
